import { createQuery, filterNilValue } from '@datorama/akita';
import { isEqual } from 'lodash-es';
import { distinctUntilChanged, map } from 'rxjs';
import userContextStore from 'context/UserContext/store';
import LanguageCodes from 'resources/json/LanguageCodes.json';
import { type LanguageCode } from 'types/models';

export const userContextQuery = createQuery(userContextStore);

/** The language the backend answers in: the user's language when supported, else English. */
export function toSupportedLanguage(language: string | undefined): LanguageCode {
   return (LanguageCodes.map(({ value }) => value).includes(language ?? '') ? language : 'en') as LanguageCode;
}

export const context$ = userContextQuery.select();

export const userId$ = userContextQuery.select('id');
export const notifications$ = userContextQuery.select('notifications');
export const organisations$ = userContextQuery.select('organisations');
export const reportingStandards$ = userContextQuery.select('reportingStandards');
export const reportingPeriods$ = userContextQuery.select('periods');

export const pageSize$ = userContextQuery.select('pageSize').pipe(filterNilValue(), distinctUntilChanged());
export const locale$ = userContextQuery.select('locale');
export const language$ = userContextQuery.select('lang');
export const supportedLanguage$ = language$.pipe(map(toSupportedLanguage));
export const includeSubsidiaries$ = userContextQuery.select('includeSubsidiaries');
export const loading$ = userContextQuery.selectLoading();
export const groups$ = userContextQuery.select('groups');
export const rules$ = userContextQuery.select('rules');
export const layouts$ = userContextQuery.select('layouts');
export const reportEditorMergeFieldsPreviewMode$ = userContextQuery
   .select((state) => state?.viewState?.reportEditorMergeFieldsPreviewMode)
   .pipe(distinctUntilChanged());
export const note$ = userContextQuery.select((state) => state?.viewState?.note).pipe(distinctUntilChanged());
export const homeScreenLayout$ = userContextQuery.select((state) => state?.viewState?.home ?? []).pipe(distinctUntilChanged(isEqual));
export const organisationTreeExpandedItemIds$ = userContextQuery
   .select((state) => state?.viewState?.orgaTreeExpanded ?? [])
   .pipe(distinctUntilChanged(isEqual));
export const organisationsViewOrder$ = userContextQuery.select((state) => state?.viewState?.organisationsViewOrder).pipe(distinctUntilChanged());
export const reducedContext$ = userContextQuery.select(['id', 'firstName', 'lastName', 'userName', 'email', 'oAuthProvider', 'image', 'publicKeys']);
